import React from 'react'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { CalendarProvider } from './src/components'

export function shouldUpdateScroll() {
  window.scrollTo(0, 0)
  ScrollTrigger.refresh()
  return false
}

export function wrapPageElement({ element, props }) {

  if(props.location.pathname.includes('atd')){
    return element
  }

  return (
    <CalendarProvider>
      {element}
    </CalendarProvider>
  )
}